module.exports = __webpack_public_path__ + "img/checklist.cf77ba31.png";